import React from 'react'
import {Form, Input, Button, Row, Col, Typography, InputNumber, message} from "antd";
import {useHistory} from 'react-router-dom';
import validator from 'validator'
import {RightOutlined} from '@ant-design/icons';
import {useAuth} from "../../hooks";
import {collection, query, where, getDocs} from "firebase/firestore";
import {firestore} from "../../services/firebase";

const Register = () => {

  const {Title} = Typography;
  const history = useHistory();
  const {signUp} = useAuth();


  const onFinish = async (values) => {

    const {correo, telefono} = values;

    if (!validator.isEmail(correo)) {
      message.error('Ingresa un correo electrónico valido');
      return false;
    }

    const q1 = query(collection(firestore, "usuarios"), where("correo", "==", correo));
    const q2 = query(collection(firestore, "usuarios"), where("telefono", "==", telefono));
    const querySnapshot1 = await getDocs(q1);
    const querySnapshot2 = await getDocs(q2);
    let count = 0;
    querySnapshot1.forEach((doc) => {
      count++
    });
    querySnapshot2.forEach((doc) => {
      count++
    });
    if (count > 0) {
      message.warning('El usuario ya exite')
    } else {
      message.success('Usuario registrado')
      signUp(values);
      history.push('/dashboard');
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <>
      <Form
        name="basic"
        layout="vertical"
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
      >
        <Row
          gutter={{xs: 10, sm: 10, md: 10, lg: 10}}
          style={{marginLeft: 0, marginTop: 20, marginBottom: 20}}
        >
          <Title level={4}>Crear cuenta</Title>
        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Nombre"
              name="nombre"
              rules={[{required: true, message: "Porfavor ingrese su correo nombre"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Apellidos"
              name="apellidos"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Correo electrónico"
              name="correo"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Número de teléfono"
              name="telefono"
              rules={[{required: true, message: "Porfavor ingrese su número de teléfono"}]}
            >
              <InputNumber minLength={10} maxLength={10} autoComplete="off" style={{width: '100%'}}/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="País"
              name="pais"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Ciudad"
              name="ciudad"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Institución (Empresa)"
              name="empresa"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>

          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 12, offset: 0}}
            lg={{span: 12, offset: 0}}
            xxl={{span: 12, offset: 0}}
          >
            <Form.Item
              label="Ocupación"
              name="ocupacion"
              rules={[{required: true, message: "Porfavor ingrese su correo electrónico"}]}
            >
              <Input autoComplete="off"/>
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={{xs: 10, sm: 10, md: 10, lg: 10}}>
          <Col
            xs={{span: 24, offset: 0}}
            sm={{span: 24, offset: 0}}
            md={{span: 8, offset: 16}}
            lg={{span: 8, offset: 16}}
            xxl={{span: 8, offset: 16}}
          >
            <Form.Item>
              <Button
                icon={<RightOutlined/>}
                type="primary"
                htmlType="submit"
                block
                size="large"
              >
                Ingresar
              </Button>
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </>
  )
}

export default Register
